import {
  Component,
  HostListener,
  Inject,
  OnInit,
  ViewChild
} from '@angular/core';
import { Router } from '@angular/router';
import { AppConfig, appConfigService } from '@app/config';
import { TreeViewProviderDirective } from '@app/providers/tree-view-provider.service';
import { ListViewProviderDirective, UIComponents, ViewData } from '@ntap/core';
import { MessageService, TreeDragDropService, TreeNode } from 'primeng/api';
import { Tree } from 'primeng/tree';
import { map, Observable, tap } from 'rxjs';
import { HierarhijaComponent } from '../hierarhija/hierarhija.component';
import { EarhivTreeNode } from '../hierarhija/types';

@Component({
  selector: 'app-hierarhija-posebni-popis',
  templateUrl: './hierarhija-posebni-popis.component.html',
  styleUrls: ['./hierarhija-posebni-popis.component.scss'],
  providers: [
    TreeDragDropService,
    MessageService,
    TreeViewProviderDirective,
    {
      provide: ListViewProviderDirective,
      useExisting: TreeViewProviderDirective
    }
  ]
})
export class HierarhijaPosebniPopisComponent implements OnInit {
  @ViewChild(Tree)
  public tree: Tree;
  public showDeleteButton = false;
  public loading = false;
  public selectedNodesCount = 0;
  public tableToolbarCompId = UIComponents.LISTTOOLBAR;
  public tableToolbarCompId1 = UIComponents.LISTACTIONBAR;

  files1$: Observable<TreeNode[]>;
  _selectedFiles: TreeNode[];
  actions$: Observable<any[]>;
  loadingState$: Observable<boolean>;
  displayItems$: Observable<ViewData>;

  propagateSelectionUp = false;
  propagateSelectionDown: boolean;

  @HostListener('keydown.shift', ['$event'])
  onKeyDown() {
    this.propagateSelectionDown = true;
  }

  @HostListener('keyup.shift', ['$event'])
  onKeyUp() {
    this.propagateSelectionDown = false;
  }

  constructor(
    @Inject(appConfigService) appConfig: AppConfig,
    private msg: MessageService,
    private router: Router,
    private listViewProvider: TreeViewProviderDirective
  ) {
    console.log('appConfig.apiHost: ' + appConfig.apiHost);
    this.actions$ = this.listViewProvider.view$.pipe(
      map((response: any) => {
        return response.actions;
      })
    );
    this.loadingState$ = this.listViewProvider.loadingState$;
    const rootsViewState = {
      $paging_offset: 0,
      $paging_limit: 600
    };
    this.files1$ = this.listViewProvider.treeViewData$;
    this.listViewProvider.viewName = null as any;
    this.listViewProvider.viewState = null as any;
    this.listViewProvider.rootViewName =
      'poseban_popis_gradiva_s_rokovima_cuvanja';
    this.listViewProvider.rootViewState = rootsViewState;
    this.listViewProvider.mapRoots = this.mapRoots;
    this.listViewProvider.mapNodes = this.mapNodes;
  }

  ngOnInit() {
    this.selectedFiles = [];
    this.listViewProvider.viewName = 'jedinica_gradiva';
    this.listViewProvider.viewState = {
      $paging_offset: 0,
      $paging_limit: 100
    };
  }

  public mapRoots = (rootsResponse: Observable<any[]>): Observable<any[]> => {
    return rootsResponse.pipe(
      map((roots) => {
        const rootNodes: EarhivTreeNode[] = roots
          .filter(
            (element) =>
              !element['sif~poseban_popis_gradiva_s_rokovima_cuvanja~parent_id']
          )
          .map((element: any) => {
            const node: EarhivTreeNode = {};
            node['data'] = element;
            node['label'] =
              element['sif~poseban_popis_gradiva_s_rokovima_cuvanja~naziv'] ||
              '';
            node['icon'] = 'pi pi-fw pi-book';
            node['children'] = [];
            node['leaf'] = false;
            node['selectable'] = false;
            node['offset'] = 0;
            return node;
          });

        const mapped: EarhivTreeNode[] = rootNodes.map((rootNode: any) => {
          return this.mapRootChildren(roots, rootNode);
        });

        return mapped;
      })
    );
  };

  public mapNodes = (response: any, parentNode?: EarhivTreeNode): any => {
    const loadedNodes: EarhivTreeNode[] = [];

    //brisanje loadMoreNode da se ne bi ponavljali u listi
    parentNode?.children?.pop();

    response.forEach((element: any) => {
      const node: EarhivTreeNode = {};
      node['data'] = element;
      node['label'] =
        (element['en~jedinica_gradiva~arhivska_oznaka'] || '') +
        ' ' +
        (element['en~jedinica_gradiva~glavni_naziv'] || '');
      node['icon'] = 'pi pi-fw pi-file';
      node['children'] = [];
      node['lockedIconClass'] = element['en~jedinica_gradiva~locked']
        ? 'lock-status p-treenode-icon pi pi-lock'
        : 'lock-status p-treenode-icon pi pi-lock-open';
      node['children'] = [];
      node['leaf'] = false;
      node['selectable'] = true;
      node['id'] = HierarhijaComponent.getElementId(element);
      node['offset'] = 0;

      // definiramo vezu prema parent node-u na podacima, ali preko defineProperty da izbjegnemo cirkularnu serijalizaciju u JSON
      Object.defineProperty(element, '$parentNode', {
        value: 'static',
        writable: true
      });

      element.$parentNode = parentNode;

      loadedNodes.push(node);
    });

    // dodajemo loadMoreNode ako imamo neki response
    if (loadedNodes.length > 0) {
      const loadMoreNode: any = {
        type: 'url',
        selectable: false,
        draggable: false,
        droppable: false,
        label: 'Učitaj više.',
        // icon: "pi pi-arrow-down",
        parent: parentNode
      };

      Object.defineProperty(loadMoreNode, '$parentNode', {
        value: 'static',
        writable: true
      });

      loadMoreNode.$parentNode = parentNode;
      loadMoreNode.parent = parentNode;
      loadedNodes.push(loadMoreNode);
    }

    return loadedNodes;
  };

  private mapRootChildren(roots: any[], rootNode: any) {
    roots.filter((current: any) => {
      if (
        current['sif~poseban_popis_gradiva_s_rokovima_cuvanja~parent_id'] !=
          null &&
        rootNode.data['sif~poseban_popis_gradiva_s_rokovima_cuvanja~id'] ==
          current['sif~poseban_popis_gradiva_s_rokovima_cuvanja~parent_id']
      ) {
        const node: EarhivTreeNode = {};
        node['data'] = current;
        node['icon'] = 'pi pi-fw pi-book';
        node['children'] = [];
        node['leaf'] = false;
        node['selectable'] = false;
        node['offset'] = 0;
        rootNode.children.push(node);
        this.mapRootChildren(roots, node);
        (node as any)['loadJedinice'] = node.children.length == 0;
        // definiramo vezu prema parent node-u na podacima, ali preko defineProperty da izbjegnemo cirkularnu serijalizaciju u JSON
        Object.defineProperty(node, '$parentNode', {
          value: 'static',
          writable: true
        });
        (node as any).$parentNode = rootNode;
        node['label'] =
          current['sif~poseban_popis_gradiva_s_rokovima_cuvanja~naziv'] || '';
        return false;
      }
      return false;
    });
    return rootNode;
  }

  onNodeDrop(event: any) {
    if (event.dropNode.leaf) {
      console.log('onDrop', event, event.node);

      this.msg.add({
        severity: 'error',
        summary: 'Odaberite odgovarajući folder.',
        detail: 'Odaberite odgovarajući folder.'
      });
    } else {
      event.accept();
      this.tree.updateSerializedValue();
    }
  }

  loadMore(node: any) {
    const posebanPopisId = node.parent.data[
      'sif~poseban_popis_gradiva_s_rokovima_cuvanja~id'
    ]
      ? node.parent.data['sif~poseban_popis_gradiva_s_rokovima_cuvanja~id']
      : null;
    const jedinicaGradivaId = node.parent.data['en~jedinica_gradiva~id']
      ? node.parent.data['en~jedinica_gradiva~id']
      : null;

    const requestState = posebanPopisId
      ? Object.assign({}, this.listViewProvider.viewState, {
          'en~jedinica_gradiva~klasa': posebanPopisId,
          $paging_offset: node.parent.offset,
          $paging_limit: 100
        })
      : jedinicaGradivaId
      ? Object.assign({}, this.listViewProvider.viewState, {
          'en~jedinica_gradiva~nadredena_jedinica_gradiva': jedinicaGradivaId,
          $paging_offset: node.parent.offset,
          $paging_limit: 100
        })
      : null;

    this.listViewProvider
      .loadMore(node.parent, requestState, 100)
      .subscribe((res) => {
        if (res.length == 0) {
          this.msg.add({
            severity: 'info',
            summary: 'Obavijest',
            detail: `Učitali ste sve podatke za ${node.parent.label}`
          });
        }
      });
  }

  nodeExpand(event: any) {
    const posebanPopisId = event.node.data[
      'sif~poseban_popis_gradiva_s_rokovima_cuvanja~id'
    ]
      ? event.node.data['sif~poseban_popis_gradiva_s_rokovima_cuvanja~id']
      : null;
    const jedinicaGradivaId = event.node.data['en~jedinica_gradiva~id']
      ? event.node.data['en~jedinica_gradiva~id']
      : null;

    const requestState = posebanPopisId
      ? Object.assign({}, this.listViewProvider.viewState, {
          'en~jedinica_gradiva~klasa': posebanPopisId
        })
      : jedinicaGradivaId
      ? Object.assign({}, this.listViewProvider.viewState, {
          'en~jedinica_gradiva~nadredena_jedinica_gradiva': jedinicaGradivaId
        })
      : null;

    this.loading = true;
    this.listViewProvider
      .nodeExpand(event.node, requestState, 100)
      .pipe(
        tap(() => {
          this.loading = false;
        })
      )
      .subscribe();
  }

  nodeCollapse(event: any) {
    this.listViewProvider.nodeCollapse(event.node);
  }

  get selectedFiles() {
    return this._selectedFiles;
  }

  set selectedFiles(values) {
    if (this.listViewProvider) {
      this.listViewProvider.selectedItems = values.map((node) => node);
    }
    this._selectedFiles = values;
  }
}
